import { atom } from 'jotai';

export const selectedDateAtom = atom(new Date());
export const selectedMonthAtom = atom(
  get => get(selectedDateAtom).getUTCMonth() + 1,
);
export const selectedYearAtom = atom(get =>
  get(selectedDateAtom).getUTCFullYear(),
);
